// importing the action types and a updateObject helper
import*as actionTypes from'../actions/actionTypes';var initialState={open:false,menuType:null,helperProps:{},elementId:null};var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];// must return the same state or an updated version
switch(action.type){// set user auth
case actionTypes.OPEN_CONTEXT_MENU:return Object.assign({},state,{open:true,menuType:action.menuType,helperProps:action.helperProps,elementId:action.elementId});case actionTypes.CLOSE_CONTEXT_MENU:{return initialState;}default:return state;}};export default reducer;


//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/contextMenu.js
// module id = 1873
// module chunks = 29